import React from 'react';
import { AlertCircle, Clock, Brain, FileQuestion } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-87">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="max-w-3xl mx-auto" data-id="element-89">
          <h2 className="text-3xl font-bold text-slate-900 mb-6 text-center" data-id="element-90">
            Cada semana atendés niños con dislexia...
            <span className="block text-amber-600 mt-2" data-id="element-91">
              pero el trabajo invisible te está agotando
            </span>
          </h2>

          <p className="text-lg text-slate-600 mb-10 text-center" data-id="element-92">
            No aparece en tu agenda. No se factura. Pero ocupa tu cabeza todo el
            tiempo.
          </p>

          <div className="grid gap-6 mb-12" data-id="element-93">
            {['Pensar actividades.', 'Adaptarlas al nivel del niño.', 'Buscar material que no sea infantil.', 'Probar si funciona.', 'Rehacerlo todo para el próximo paciente.'].map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg bg-slate-50 border border-slate-100" data-id="element-94">
                <div className="bg-amber-100 p-2 rounded-full mt-0.5" data-id="element-95">
                  <AlertCircle className="w-5 h-5 text-amber-600" data-id="element-96" />
                </div>
                <p className="text-slate-700 font-medium" data-id="element-97">{item}</p>
              </div>)}
          </div>

          <div className="bg-slate-900 text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-98">
            <div className="relative z-10" data-id="element-99">
              <h3 className="text-xl font-bold mb-4 text-amber-400" data-id="element-100">
                Y lo más frustrante es esto:
              </h3>
              <p className="mb-6 text-slate-300" data-id="element-101">
                No es falta de formación. No es falta de compromiso. No es que
                "no sabés qué hacer".
              </p>
              <p className="text-lg font-medium border-l-4 border-amber-500 pl-4" data-id="element-102">
                Es que nadie te dio un sistema completo, paso a paso, para
                trabajar dislexia en sesión real.
              </p>
            </div>
          </div>

          <div className="mt-16" data-id="element-103">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center" data-id="element-104">
              El problema real (el que casi nadie dice)
            </h3>
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-105">
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 hover:border-teal-200 transition-colors" data-id="element-106">
                <Clock className="w-8 h-8 text-teal-600 mb-4" data-id="element-107" />
                <p className="font-medium text-slate-800" data-id="element-108">
                  Pasás más tiempo planificando que interviniendo
                </p>
              </div>
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 hover:border-teal-200 transition-colors" data-id="element-109">
                <FileQuestion className="w-8 h-8 text-teal-600 mb-4" data-id="element-110" />
                <p className="font-medium text-slate-800" data-id="element-111">
                  Tenés material suelto, sin continuidad ni criterio clínico
                </p>
              </div>
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 hover:border-teal-200 transition-colors" data-id="element-112">
                <Brain className="w-8 h-8 text-teal-600 mb-4" data-id="element-113" />
                <p className="font-medium text-slate-800" data-id="element-114">
                  Dudás si lo que estás haciendo es suficiente o correcto
                </p>
              </div>
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 hover:border-teal-200 transition-colors" data-id="element-115">
                <AlertCircle className="w-8 h-8 text-teal-600 mb-4" data-id="element-116" />
                <p className="font-medium text-slate-800" data-id="element-117">
                  Sentís que improvisás más de lo que te gustaría
                </p>
              </div>
            </div>

            <p className="text-center text-lg font-medium text-slate-700 mt-10" data-id="element-118">
              Te llevás trabajo a tu casa todas las semanas.
              <br data-id="element-119" />
              <span className="text-slate-500 text-base font-normal mt-2 block" data-id="element-120">
                Las psicopedagogas no se cansan de acompañar niños. Se cansan de
                tener que sostener todo solas.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}